import { useEffect } from "react";

const SCROLL_END_DELAY = 600;

/**
 * 滚动时给 html 添加 is-scrolling，用于显示滚动条；停止滚动后隐藏。
 */
export function ScrollbarOnScroll() {
  useEffect(() => {
    const root = document.documentElement;
    let timer: ReturnType<typeof setTimeout>;

    const onScroll = () => {
      root.classList.add("is-scrolling");
      clearTimeout(timer);
      timer = setTimeout(() => {
        root.classList.remove("is-scrolling");
      }, SCROLL_END_DELAY);
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(timer);
      root.classList.remove("is-scrolling");
    };
  }, []);

  return null;
}
